import React, { useState } from 'react';
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { getFirstLetterOfWords } from '@/utils/helpers';

const CustomAvatar = ({
    name,
    avatarUrl,
    size = 'small',
    backgroundColor = '#31cdf5',
}) => {
    const [imageError, setImageError] = useState(false);
    const initials = name ? getFirstLetterOfWords(name) : '';

    if (avatarUrl && !imageError) {
        return (
            <Avatar
                size={size}
                icon={<UserOutlined />}
                src={avatarUrl}
                onError={() => setImageError(true)}
            />
        );
    }

    return (
        <Avatar
            size={size}
            style={{
                backgroundColor,
                verticalAlign: 'middle',
            }}
        >
            {initials}
        </Avatar>
    );
};

export default CustomAvatar;
